var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostgresql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.739,
    height: 170.631,
    viewBox: "0 0 43.852 45.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 12.465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.781 32.885c.288-2.394.201-2.745 1.984-2.357l.453.04c1.371.062 3.164-.22 4.218-.71 2.268-1.053 3.613-2.81 1.377-2.348-5.102 1.052-5.453-.675-5.453-.675C40.747 18.842 43 8.696 41.055 6.213c-5.301-6.774-14.478-3.57-14.631-3.488l-.05.01a18.185 18.185 0 0 0-3.403-.355c-2.308-.038-4.06.605-5.389 1.613 0 0-16.37-6.745-15.609 8.482.162 3.239 4.643 24.51 9.987 18.085 1.954-2.35 3.842-4.336 3.842-4.336.937.623 2.06.94 3.236.826l.091-.077c-.028.292-.016.577.037.915-1.377 1.538-.972 1.808-3.725 2.375-2.785.574-1.149 1.595-.08 1.863 1.294.323 4.29.782 6.315-2.052l-.08.324c.54.432.503 3.105.58 5.015.076 1.91.204 3.693.593 4.744.39 1.05.849 3.758 4.467 2.983 3.023-.648 5.335-1.58 5.545-10.255",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 3.7929748500000007,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.813 27.51c-5.102 1.052-5.453-.675-5.453-.675 5.387-7.993 7.64-18.14 5.696-20.623-5.302-6.773-14.479-3.57-14.632-3.487l-.05.009a18.194 18.194 0 0 0-3.403-.355c-2.309-.037-4.06.606-5.389 1.613 0 0-16.37-6.744-15.61 8.483.163 3.239 4.643 24.51 9.988 18.085 1.954-2.35 3.841-4.336 3.841-4.336.937.623 2.06.94 3.236.826l.092-.077c-.029.292-.016.577.036.915-1.377 1.538-.972 1.808-3.724 2.375-2.785.574-1.15 1.595-.081 1.863 1.295.323 4.29.782 6.315-2.052l-.08.324c.539.432.918 2.81.854 4.966-.063 2.157-.106 3.637.32 4.793.425 1.156.848 3.758 4.466 2.983 3.024-.648 4.59-2.327 4.809-5.128.154-1.991.504-1.697.526-3.477l.281-.843c.324-2.699.052-3.57 1.914-3.164l.453.04c1.37.062 3.165-.221 4.218-.71 2.268-1.053 3.613-2.81 1.377-2.348z",
    fill: "#336791",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.894 29.057c-.14 5.022.036 10.08.527 11.308.492 1.23 1.544 3.62 5.163 2.845 3.023-.648 4.123-1.903 4.6-4.671.351-2.037 1.03-7.694 1.116-8.853M17.557 3.88S1.175-2.816 1.937 12.41c.161 3.24 4.643 24.512 9.987 18.087 1.953-2.35 3.72-4.193 3.72-4.193M26.406 2.658c-.567.178 9.113-3.539 14.614 3.49 1.943 2.484-.309 12.63-5.695 20.624",
    strokeWidth: 1.26432495
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.325 26.772s.35 1.727 5.453.674c2.235-.461.89 1.296-1.377 2.349-1.861.863-6.033 1.085-6.1-.109-.176-3.078 2.195-2.143 2.024-2.914-.155-.695-1.215-1.377-1.917-3.077-.612-1.485-8.397-12.866 2.16-11.176.386-.08-2.754-10.041-12.633-10.203-9.878-.162-9.554 12.147-9.554 12.147",
    strokeLinejoin: "bevel",
    strokeWidth: 1.26432495
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.13 27.824c-1.378 1.539-.973 1.809-3.725 2.376-2.785.574-1.15 1.595-.081 1.862 1.295.324 4.29.783 6.315-2.052.617-.863-.004-2.24-.85-2.59-.41-.17-.957-.382-1.66.404z",
    strokeWidth: 1.26432495
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.04 27.798c-.14-.905.296-1.981.763-3.24.702-1.89 2.322-3.779 1.027-9.771-.966-4.466-7.445-.93-7.449-.324-.004.605.293 3.069-.108 5.938-.524 3.744 2.382 6.91 5.728 6.586",
    strokeWidth: 1.26432495
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.498 14.372c-.03.207.378.759.91.832.53.074.985-.357 1.014-.563.029-.207-.378-.435-.91-.51-.532-.073-.986.035-1.014.241z",
    fill: "#fff",
    strokeWidth: 0.42144165000000006,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.667 13.95c.03.207-.378.759-.91.833-.531.074-.986-.357-1.015-.564-.028-.207.38-.435.91-.509.532-.074.986.034 1.015.24z",
    fill: "#fff",
    strokeWidth: 0.21077154,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.567 12.52c.088 1.621-.349 2.726-.404 4.453-.082 2.51 1.197 5.383-.73 8.26",
    strokeWidth: 1.26432495
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostgresql);
export default __webpack_public_path__ + "static/media/postgresql.7e9d90fa5221f3a091bed86db00875e4.svg";
export { ForwardRef as ReactComponent };